import app from "@/main";

export const useBuefy = () => {
    return app?.$buefy;
};
